<div class="px-6">
  <div class="table-container">
    <table mat-table matSort [dataSource]="dataSource" class="text-wrap">
      <ng-container matColumnDef="traded-at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Traded At</th>
        <td mat-cell *matCellDef="let trade">
          {{ trade.createdAt | date : "MMM d, y, hh:mm a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="commodity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Commodity</th>
        <td mat-cell *matCellDef="let trade">
          {{ trade.commodity }}
          @if (trade.product_type) { - {{ trade.product_type }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="grade">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Grade</th>
        <td mat-cell *matCellDef="let trade">{{ trade.grade }}</td>
      </ng-container>

      <ng-container matColumnDef="volume_value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Volume</th>
        <td mat-cell *matCellDef="let trade">
          {{ trade.volume_value }} {{ trade.units }}
        </td>
      </ng-container>

      <ng-container matColumnDef="price_value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
        <td mat-cell *matCellDef="let trade">
          {{ trade.currency }} ${{ trade.price | priceType }} /
          {{ trade.price_units }}
        </td>
      </ng-container>

      <ng-container matColumnDef="delivery_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Delivery</th>
        <td mat-cell *matCellDef="let trade">
          {{ trade.destination.split(",")[0] }} - {{ trade.delivery_type }}
        </td>
      </ng-container>

      <ng-container matColumnDef="shipping">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Shipping</th>
        <td mat-cell *matCellDef="let trade">
          {{ trade.ship_begin | date : "MMM d, y" }} -
          {{ trade.ship_end | date : "MMM d, y" }} <br />
        </td>
      </ng-container>

      <tr
        id="title-cols"
        class="hover:none"
        mat-header-row
        *matHeaderRowDef="displayColumns"
      ></tr>
      <tr
        id="data-rows"
        mat-row
        *matRowDef="let trade; columns: displayColumns"
      ></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="7" class="">No data</td>
      </tr>
    </table>
  </div>
  <mat-paginator
    class="mat-paginator-sticky"
    [pageSizeOptions]="[20, 30, 50]"
    showFirstLastButtons
  ></mat-paginator>
</div>
